export const properties = {
    ERROR_MESSAGE: {
        GENERIC_ERROR: "No Results Found. Please check the search criteria and try again.",
        EMPTY_INPUT: "Please provide at least one search criteria.",
        INVALID_TOKEN: "Invalid Token.",
        EMPTY_LAST4: "Please fill last 4 characters of your card number.",
        EMPTY_FIRST6: "Please fill first 6 characters of your card number.",
        INVALID_DATE_RANGE: "Invalid Date Range.",
        INVALID_DATE: "Start date can not be greater than End date.",
        ONLY_DATE_RANGE: "Please provide at least search criteria. Searching only with date range is not allowed."
    },
    TOOLTIP_CONTENT: {
        DATE_RANGE_TOOLTIP: "By default last month date range is selected. You can change by selecting the drop down below.",
        TOKEN_NUMBER_TOOLTIP: "Sample: S12345567812345678. Token is 17 characters long.",
        CARD_NUMBER_TOOLTIP: "Enter both first 6 and last 4 characters of card."
    },
    MESSAGE_LIST: {
        LOGOUT_MSG: "You have been logged out from WPS Transaction Portal. Please login to continue.",
    },
}
